var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "line-of-sight" },
    [
      _vm.dataLoaded && _vm.showModal
        ? _c(
            "modal-box",
            {
              attrs: { open: _vm.dataLoaded && _vm.showModal, width: "1080px" },
              domProps: {
                onClose: () => (_vm.showModal = false),
                enableHeader: true,
                enableFooter: true,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "flex-row flex-1" }, [
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.losDescription.category))]),
                    ]),
                    _c("span", { staticClass: "separator ml-6 mr-4 mt-2" }),
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.losDescription.classification)),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _c("span", [
                _c("div", { staticClass: "flex-col edit-los-description" }, [
                  _c("div", { staticClass: "mt-3 los-description" }, [
                    _c(
                      "label",
                      {
                        staticClass: "los-text-label",
                        attrs: { for: "losOldValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("oldValue")))]
                    ),
                    _c("textarea", {
                      staticClass: "los-text-input",
                      attrs: {
                        id: "losOldValue",
                        placeholder: _vm.$t("value"),
                        readonly: true,
                      },
                      domProps: { value: _vm.losOldValue },
                    }),
                  ]),
                  _c("div", { staticClass: "mt-3 los-description" }, [
                    _c(
                      "label",
                      {
                        staticClass: "los-text-label",
                        attrs: { for: "losValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("newValue")))]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.losDescription.value,
                          expression: "losDescription.value",
                        },
                      ],
                      staticClass: "los-text-input",
                      attrs: { id: "losValue", placeholder: _vm.$t("value") },
                      domProps: { value: _vm.losDescription.value },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.losDescription,
                            "value",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "mt-3 los-description" }, [
                    _c(
                      "label",
                      {
                        staticClass: "los-text-label",
                        attrs: { for: "losValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("reason")))]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.losDescription.updComment,
                          expression: "losDescription.updComment",
                        },
                      ],
                      staticClass: "los-text-input",
                      attrs: { id: "losValue", placeholder: _vm.$t("reason") },
                      domProps: { value: _vm.losDescription.updComment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.losDescription,
                            "updComment",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { class: _vm.errorExists ? "error-text" : "" }, [
                    _vm.errorExists
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("thisFieldIsMandatory"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("br"),
              ]),
              _c(
                "span",
                {
                  staticClass: "footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("div", { staticClass: "flex-row reverse" }, [
                    _c(
                      "div",
                      { staticClass: "flex-col flex-align-end" },
                      [
                        _c(
                          "adam-button",
                          {
                            attrs: { secondary: "", icon: "ic-station" },
                            on: { click: _vm.save },
                          },
                          [_vm._v("Save")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      !_vm.dataLoaded
        ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
        : _vm._e(),
      _c("content-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex-row flex-1",
                    staticStyle: { "align-items": "center" },
                  },
                  [
                    _c("div", { staticClass: "flex-col flex-2" }, [
                      _c("div", { staticClass: "flex-row flex-1" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex-col ml-5",
                            staticStyle: { width: "30rem" },
                          },
                          [
                            _c("CustomSelect", {
                              staticClass: "select",
                              attrs: {
                                options: _vm.ampCategories,
                                default: _vm.defaultCategory,
                                displayKey: "category",
                              },
                              on: { input: _vm.onProcessChange },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "flex-row" }, [
                  _c("div", { staticClass: "flex-col flex-1" }),
                  _c(
                    "div",
                    { staticClass: "flex-col flex-12" },
                    _vm._l(_vm.filteredData, function (losData) {
                      return _c("AMProcessClassificaton", {
                        key: losData.id,
                        staticClass: "mb-1",
                        attrs: { losData: losData },
                        on: { "on-edit": _vm.editComment },
                      })
                    }),
                    1
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }